import { Accordion as SparkAccordion } from '@uswitch/spark.accordion'
import { Type } from '@uswitch/spark.type'
import { useEntity } from '@uswitch/ev-utils/lib/context/selectors'
import AccordionItem from './item'
import { getVariantPath } from '@uswitch/ev-utils/lib/get-variant-path'
import withComponentBase from '../../helpers/with-component-base'

export const accordionStylePath = (field, variant) =>
  getVariantPath({
    atomicType: 'compounds',
    componentId: 'accordion',
    variantName: variant,
    field,
  })

const useIcon = item => useEntity(item).icon

const Accordion = ({ name, title, items, variant = 'base' }) => {
  const hasIcons = items.map(useIcon).some(item => item !== undefined)

  return (
    <div
      sx={{
        variant: hasIcons
          ? accordionStylePath('integrationWrapper.withIcons', variant)
          : accordionStylePath('integrationWrapper.withoutIcons', variant),
      }}
    >
      <If condition={title}>
        <Type.H2
          sx={{
            variant: accordionStylePath('mainTitle', variant),
          }}
        >
          {title}
        </Type.H2>
      </If>

      <SparkAccordion expandSingleSection={true}>
        <For each='item' of={items} index='idx'>
          <AccordionItem
            accordionName={name}
            entity={item}
            key={idx}
            itemIndex={idx}
            variant={variant}
          />
        </For>
      </SparkAccordion>
    </div>
  )
}

export default withComponentBase(Accordion, {
  withHeaderFooter: true,
})
